import { serverLogger } from "~/logger.server";

type AuthState = {
	redirectTo?: string;
	companyId?: number;
	permitPublicId?: string;
};

export const createAuthState = ({ redirectTo, companyId, permitPublicId }: AuthState) => {
	if (!redirectTo && !companyId && !permitPublicId) {
		return undefined;
	}
	return JSON.stringify({ redirectTo, companyId, permitPublicId });
};

export const parseAuthState = (
	state: string | null,
): { redirectTo: string | null; companyId: number | null; permitPublicId: string | null } => {
	if (!state) {
		return { redirectTo: null, companyId: null, permitPublicId: null };
	}
	try {
		const parsed = JSON.parse(state);
		const companyId = Number(parsed.companyId);
		return {
			redirectTo: parsed.redirectTo || null,
			companyId: Number.isInteger(companyId) && companyId > 0 ? companyId : null,
			permitPublicId: parsed.permitPublicId || null,
		};
	} catch (e) {
		serverLogger.error("Failed to parse state", e instanceof Error ? e : new Error("Unknown Error"), {
			logGroup: "WORKOS_ERROR",
			state,
		});
		return { redirectTo: null, companyId: null, permitPublicId: null };
	}
};
